import bodymovin from 'lottie-web';

export const isMobile = {
	Android() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	IOS() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any() {
		return (
			isMobile.Android() ||
			isMobile.BlackBerry() ||
			isMobile.IOS() ||
			isMobile.Opera() ||
			isMobile.Windows()
		);
	},
};

export function preventAction(elem) {
	jQuery(elem).each(function () {
		jQuery(this).click(function (el) {
			el.stopPropagation();
			el.preventDefault();
		});
	});
}

export function calcMaxHeight(elem) {
	const arrHeight = [];

	jQuery(elem).each(function () {
		arrHeight.push($(this).first().outerHeight());
	});

	return Math.max(...arrHeight);
}

export function setEqualHeight(elem) {
	jQuery(elem).each(function () {
		jQuery(this).height(calcMaxHeight(elem));
	});
}

export function toggleBodyLock() {
	jQuery('body').toggleClass('lock');
}

export const animateCSS = (node, animation, prefix = 'animate__') => {
	return new Promise((resolve, reject) => {
		const animationName = `${prefix}${animation}`;

		node.classList.add(`${prefix}animated`, animationName);

		function handleAnimationEnd(event) {
			event.stopPropagation();
			node.classList.remove(`${prefix}animated`, animationName);
			resolve('Animation ended');
		}

		node.addEventListener('animationend', handleAnimationEnd, {
			once: true,
		});
	});
};

export function setAnimatedIcon() {
	const animatedImages = document.querySelectorAll(
		'.feature-box__animation-container'
	);

	[...animatedImages].forEach((el) => {
		const animationName = el.closest('.feature-box__img-animated').id;
		const animationParent = el.closest('.feature-box');
		const staticImage = animationParent.querySelector(
			'.feature-box__img-static'
		);
		const direction = 1;

		const animationItem = bodymovin.loadAnimation({
			container: el,
			animType: 'svg',
			loop: false,
			autoplay: false,
			path: AssetsPath.url + `/animations/${animationName}.json`,
			//path: `/wp-content/themes/nayax/resources/animation/${animationName}.json`
		});

		animationItem.addEventListener('complete', function () {
			staticImage.classList.remove('transparent');
		});

		animationParent.addEventListener('mouseenter', (e) => {
			staticImage.classList.add('transparent');
			animationItem.setDirection(direction);
			animationItem.play();
		});

		animationParent.addEventListener('mouseleave', (e) => {
			animationItem.setDirection(-direction);
			animationItem.play();
		});
	});
}

export function setAnimatedIconFeatures() {
	const animatedImages = document.querySelectorAll(
		'.bt_features--animated'
	);

	[...animatedImages].forEach((el) => {
		const animationName = el.closest('.bt_features--animated').id;
		const animationParent = el.closest('.bt_features--item');
		const staticImage = animationParent.querySelector(
			'.bt_features--image'
		);
		const direction = 1;

		const animationItem = bodymovin.loadAnimation({
			container: el,
			animType: 'svg',
			loop: false,
			autoplay: false,
			path: AssetsPath.url + `/animations/${animationName}.json`,
		});

		animationItem.addEventListener('complete', function () {
			staticImage.classList.remove('transparent');
		});

		animationParent.addEventListener('mouseenter', (e) => {
			staticImage.classList.add('transparent');
			animationItem.setDirection(direction);
			animationItem.play();
		});

		animationParent.addEventListener('mouseleave', (e) => {
			animationItem.setDirection(-direction);
			animationItem.play();
		});
	});
}


export function sleep(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

export const vis = (function () {
	let stateKey,
		eventKey,
		keys = {
			hidden: 'visibilitychange',
			webkitHidden: 'webkitvisibilitychange',
			mozHidden: 'mozvisibilitychange',
			msHidden: 'msvisibilitychange',
		};
	for (stateKey in keys) {
		if (stateKey in document) {
			eventKey = keys[stateKey];
			break;
		}
	}
	return function (c) {
		if (c) document.addEventListener(eventKey, c);
		return !document[stateKey];
	};
})();

export function setSameHeight(selector) {
	const elements = document.querySelectorAll(selector);
	if (!elements.length) {
		return;
	}

	const elementsArray = Array.from(elements);

	elementsArray.forEach((element) => {
		element.style['min-height'] = '';
	});

	let maxHeight = elements[0].offsetHeight;
	elementsArray.forEach((element) => {
		if (maxHeight < element.offsetHeight) {
			maxHeight = element.offsetHeight;
		}
	});

	elementsArray.forEach((element) => {
		element.style['min-height'] = `${maxHeight}px`;
	});
}
